// src/context/CartContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

// Context bana rahay hain
const CartContext = createContext();

// Custom hook — isay kisi bhi component mein call kar ke cart data/functions milengay
export const useCart = () => useContext(CartContext);

// Provider component — App.js mein isi ke andar poori app wrap hogi
export const CartProvider = ({ children }) => {
  // Cart ki initial value localStorage se le rahay hain (agar pehle se saved ho)
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem("cart");
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.error("Cart load error:", error);
      return [];
    }
  });

  // Jab bhi 'cart' state change ho, localStorage mein bhi update kar do
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // Product ko cart mein add karnay ka function
  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        // Agar product pehle se cart mein hai to sirf quantity +1 kar do
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      // Naya product cart mein add karo (quantity 1 ke saath)
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  // Cart se product remove karnay ka function
  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  // Kisi product ki quantity update karnay ka function
  const updateQuantity = (id, quantity) => {
    setCart((prev) =>
      prev.map((item) => (item.id === id ? { ...item, quantity } : item))
    );
  };

  // Pura cart empty karnay ka function (jaise order complete honay ke baad)
  const clearCart = () => setCart([]);

  // Total items count (navbar icon pr dikhanay ke lye)
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  // Total price (agar chahiye to basket page pr use kar saktay hain)
  const totalPrice = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        totalItems,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};